import script from "./PlaygroundPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaygroundPage.vue?vue&type=script&setup=true&lang=ts"

import "./PlaygroundPage.vue?vue&type=style&index=0&id=26f16e5c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f16e5c"]])

export default __exports__